const Header=()=>{

    return(
        <div id='Header'>
            <div id='main-heading'>
                 <p>Hi, I am Gauri Mandot </p>
                 <p>A Frontend Developer  </p>
            </div>

            <p id='sub-heading'>I create beautifully simple user interfaces —  
               because to me,<u> simplicity is the ultimate form of luxury.</u>
            </p>
           
        </div>
    );
}

export default Header;